import React from 'react';
import Style from './formPreview.module.css';
import { InputLabel, Select, InputSublabel } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

export default function FormTitle({ field, label, value = null, id = null, onChangeForm = () => {} }) {
    const { t } = useTranslation();
    const [_value, setValue] = React.useState(null);

    const onChange = React.useCallback(
        v => {
            if (id) {
                onChangeForm(id, v);
                return;
            }
            setValue(v);
        },
        [id]
    );

    const choices = [
        {
            key: 1,
            text: t('ticket.form.preview.civility.mister'),
            value: 'M.'
        },
        {
            key: 2,
            text: t('ticket.form.preview.civility.miss'),
            value: 'Mme'
        },
        {
            key: 3,
            text: t('ticket.form.preview.civility.doctor'),
            value: 'Dr.'
        },
        {
            key: 4,
            text: t('ticket.form.preview.civility.professor'),
            value: 'Pr.'
        }
    ];

    return (
        <div className={Style['field']}>
            <InputLabel label={label} required={field.required} />
            {field.form_field.description && <InputSublabel label={field.form_field.description} />}
            <Select placeholder={t('ticket.common.action.select')} options={choices} value={id ? value : _value} onChange={value => onChange(value)} {...field} />
        </div>
    );
}
